/* eslint-disable no-underscore-dangle */

import React from 'react'
import ReactHtmlParser from 'react-html-parser'

export type RatedEntityItemProps = {
  issuer: string
  debtLevel: string
  issue: string
  deal: string
  className: string
  subClass: string
  transaction: number | string
  security: number
  bond: string
  permalink: string
  series: string
}

export type RatedEntityCellProps = {
  cellProps: any
  isUspf?: boolean
  printView?:boolean
}

export const ratedEntityFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const {
    issuer,
    debtLevel,
    issue,
    deal,
    className,
    subClass,
    transaction,
    security,
    bond,
    series
  }: RatedEntityItemProps = data._original
  let result = false

  if (
    (issuer && issuer.toLowerCase().includes(filter)) ||
    (debtLevel && debtLevel.toLowerCase().includes(filter)) ||
    (issue && issue.toLowerCase().includes(filter)) ||
    (deal && deal.toLowerCase().includes(filter)) ||
    (className && className.toLowerCase().includes(filter)) ||
    (subClass && subClass.toLowerCase().includes(filter)) ||
    (transaction && transaction.toString().toLowerCase().includes(filter)) ||
    (security && security.toString().toLowerCase().includes(filter)) ||
    (bond && bond.toLowerCase().includes(filter)) ||
    (series && series.toLowerCase().includes(filter))
  ) {
    result = true
  }

  return result
}

export const RatedEntityCell = (props: RatedEntityCellProps) => {
  const { cellProps, isUspf, printView } = props
  const {
    issuer,
    debtLevel,
    issue,
    deal,
    className,
    subClass,
    transaction,
    security,
    bond,
    permalink,
    series
  }: RatedEntityItemProps = cellProps.original
  const isPrintOrNoPermalink =  printView || !permalink
  return (
    <>
      {isUspf &&
        security &&
        ReactHtmlParser(`<strong>Security:</strong> ${security}<br />`)}
      {issuer && (isPrintOrNoPermalink ? 
      ReactHtmlParser(`<strong>Issuer:</strong> ${issuer}<br />`) :
      ReactHtmlParser(
          `<strong>Issuer:</strong> <a href=/${permalink}>${issuer}</Link> <br />`
        ))}
      {debtLevel &&
        ReactHtmlParser(`<strong>Debt Level:</strong> ${debtLevel}<br />`)}
      {issue && ReactHtmlParser(`<strong>Issue:</strong> ${issue}<br />`)}
      {deal && ReactHtmlParser(`<strong>Deal:</strong> ${deal}<br />`)}
      {className &&
        ReactHtmlParser(`<strong>Class:</strong> ${className}<br />`)}
      {subClass &&
        ReactHtmlParser(`<strong>Sub Class:</strong> ${subClass}<br />`)}
      {transaction &&
        ReactHtmlParser(`<strong>Transaction:</strong> ${transaction}<br />`)}
      {!isUspf &&
        security &&
        ReactHtmlParser(`<strong>Security:</strong> ${security}<br />`)}
      {bond && ReactHtmlParser(`<strong>Bond:</strong> ${bond}<br />`)}
      {series && ReactHtmlParser(`<strong>Series:</strong> ${series}<br />`)}
    </>
  )
}